import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {AxiosError} from "axios"
import dayjs from "dayjs"
import {AppThunk} from "../../rootReducer"
import {convertReport, getAccessToken, getSelectedRegionId, selectTestCodeByVehicleType} from "../../utils/common"
import httpService from "../../utils/httpService"
import {setToastr} from "../App/appSlice"
import {UserDealer} from "../App/models"
import {Axles, Test} from "../DvsaTest/dvsatestsSlice"
import {AnnualTest} from "../Vehicles/vehicleSlice"
export interface BookingParams {
    start: Date | null
    selectedDealer: UserDealer | null
}

export interface OverviewParams {
    dateRange: {start: Date | null; end: Date | null}
    selectedDealer: UserDealer | null
}
export interface FeesReportParams {
    dateRange: {start: Date | null; end: Date | null}
    dealerIds: UserDealer[]
    searchText: string
}
export interface Booking {
    bookingID: number
    bookingRef: string
    vehicleID?: any
    dealerID: number
    customerID?: any
    accountNo?: any
    companyName: string
    testStationID?: any
    jobNumber?: any
    customerOrderRef?: any
    testPackageID?: number | null
    testStartTime: string
    testStart: string
    testEnd: string
    testFee?: any
    laneFee?: any
    bookingStatusID?: any
    bookingTypeID: number
    addedByAppUserID: string
    addedDate: string
    updatedByAppUserID: string
    updatedDate: Date
    bookingType: string | null
    bookingStatus?: string | null
    tranType?: string | null
    reminderCall: boolean | null
    testStationName?: string | null
    testPackageName?: string | null
    registration?: string | null
    internal?: boolean | null
    overLapping: number
}

export interface Overview {
    eventDate: Date
    eventDateString: string
    weekNo: string
    eventTimes: string
    breakTimes: string | null
    totalDuration: string
    booked: number
    noShow: number
    cancelled: number
    bookedLaneFee: number
    bookedTestFee: number
    bookedDuration: string
    utilisation: number
    capacity: string
    dvsaFee: number
    profitorLossPer: number | null
    profitorLoss: number
    breakBookingId: number | null
}

export interface FeesReport {
    bookingRef: string
    bookingID: number
    bookingTypeID: number
    date: Date | null
    timing: string
    testDuration: string
    vehicleType: string
    axles: string | null
    tranType: string | null
    dealer: string
    account: string
    customerName: string
    testPackage: string
    testFee: number
    laneFee: number
    internal: boolean | null
    bookingStatus: string
    reminderCall: boolean
    sendreminderEmail: boolean
    customerOrderRef: string
    jobNumber: string
    teststationName: string
    total: number
    preparerID: string
    testType: string
    registration: string
    failureDescription: string
    preparedByDealer: boolean
    annualTestDate: Date | null
    annualTestType: string | null
    testResult: string | null
    testCertificateNumber: string | null
    expiryDate: Date | null
    numberOfDefectsAtTest: number
    numberOfAdvisoryDefectsAtTest: number
    location: string | null
    failureItemNo: string | null
    validResults: string | null
    validResultReason: string | null
}

export interface ErrorMessage {
    Error: string
    Description: string | null
}

export interface WeeklyBooking {
    id: number
    title: string
    bookingID: number
    testStart: Date
    testEnd: Date
    testStationID: number
    bookingTypeID: number
    bookingType: string
    testPackage: string | null
    registration: string | null
    bookingStatusId: number | null
    bookingStatus: string | null
    duration: string
    customer: string
    accountNo: string
    internal: boolean | null
    testPackageId: number
    testFee: number
    laneFee: number
}

export type Vehicle = {
    vehicleId: number
    registration: string
    vin: string
    make: string
    model: string
    vehicleType: string
    vehicleClass: string
    manufactureDate: any
    registrationDate: any
    annualTestExpiryDate: any
    active: boolean
    dvsaFetchDate: any
    editable: false
    axleCode: string
    annualTests: AnnualTest[] | null
}
export interface DealerTestPackage {
    testPackageID: number
    testPackageName: string
    testPackageDescription: string
    laneFee: number
    testFee: number
    duration: number
    active: boolean
    noofRecord: number | undefined
    noofRepeat: number | undefined
    testCodes: string[]
}
export interface TestPackageDetail {
    testPackageID: number
    testPackageName: string
    laneFee: number
    duration: number
    notes: null
    tests: TestDetail[]
}

export interface TestDetail {
    dvsaTestCostID: number
    code: string
    test: string
    testType: string
    axle: string | ""
    duration: number
    charges: number
}

export interface Customer {
    customerId: number
    companyName: string
    accountNo: string
    displayName: string
}

export type CustomerContact = {
    customerId: number
    customerContactId: number
    firstName: string
    lastName: string
    email: string
    phone: string
    primaryContact: boolean
    active: boolean
    updatedByAppUserID: string
    updatedDate: string
}

export interface BookingStatus {
    bookingStatusId: number
    bookingStatusName: string
}

export interface SchedulerPackageSlot {
    id: number
    bookingId: number
    title: string
    testStart: Date
    testEnd: Date
    slot: string
    testPackageId: number
    testFee: number
    laneFee: number
    duration: number
}

export interface TestStation {
    testStationID: number
    testStationName: string
    address1: string
    address2: string
    town: string
    postCode: string
    phone: string
    email: string
    active: boolean
    dealerID: number | null
    dealerDefault: boolean
}

export interface DVSAAvailability {
    start: Date
    end: Date
}
export interface NewBookingParams {
    dealerId: number
    testStart: string
    testEnd: string
    testPackageID: number | null
    registration: string | null
    customer: number | null
    testFee: number | null
    laneFee: number
    duration: number
    preparerDealerName: string | null
    preparedByDealer: boolean
}
export interface BookingDetail {
    bookingID: number
    bookingRef: string
    vehicleID: number | null
    dealerID: number
    customerID: number
    accountNo: string
    companyName: string
    testStationID: number | null
    jobNumber: string
    customerOrderRef: string
    testCode: string | null
    axleCode: string | null
    testPackageID: number | null
    testPackage: TestPackageDetail | null
    testStart: string
    testEnd: string
    testFee: number
    laneFee: number
    total: number
    notes: string
    failureDescription: string
    bookingStatusID: number | null
    bookingTypeID: number
    addedByAppUserID: string
    addedDate: string
    updatedByAppUserID: string
    updatedDate: string
    bookingType: string
    bookingStatus: string
    dealerName: string
    testStationName: string
    addedBy: string
    updatedBy: string
    recipients: string
    email: string
    phone: string
    registration: string
    make: string
    model: string
    vehicleType: string
    vehicleClass: string
    registrationDate: string | null
    manufactureDate: string | null
    annualTestExpiryDate: string | null
    dvsaFetchDate: string | null
    customer: Customer | null
    preparerID: any | ""
    loadingBookingStatus: boolean
    bookingStatusList: BookingStatus[]
    newVehicle: false
    duration: number
    tranType: string | null
    reminderCall: boolean
    confirmationEmail: boolean
    annualTests: AnnualTest[] | null
    sendReminderEmail: boolean
    cpApplied: boolean
    preparedByDealer: boolean
    preparerDealerName: string | null
    isBlocked: boolean | null
}

export interface TransactonType {
    tranType: string
    tranTypeName: string
    tranTypeText: string
}
export interface BookingReminder {
    bookingID: number
    bookingTypeID: number
    bookingRef: string
    customerName: string
    testStart: Date | null
    timing: string
    registration: string
    reminderCall: string
    reminderEmail: boolean
    confirmationEmail: boolean
    internal: boolean
    isEmailEmpty: boolean
}
export interface Bookingupdateinfo {
    id: number
    userName: string
    auditType: string
    tableName: string
    dateTimeStamp: Date
    oldValues: string
    newValues: string
    affectedColumns: string
    pkid: string
}

export interface Bookingupdateinfo {
    id: number
    userName: string
    auditType: string
    tableName: string
    dateTimeStamp: Date
    oldValues: string
    newValues: string
    affectedColumns: string
    pkid: string
}

export interface MOTCustomPrice {
    customPrice: string
    value: number
}

type MOTBookingState = {
    gettingBookings: boolean
    bookings: Booking[]
    bookingFilters: BookingParams
    overviewFilters: OverviewParams
    loadingBookingDetail: boolean
    bookingDetail: BookingDetail
    bookingDetailNoEdit: BookingDetail
    loadingMakes: boolean
    makeList: string[]
    loadingModels: boolean
    modelsList: string[]
    loadingVehicleClass: boolean
    vehicleClasses: string[]
    loadingVehicleType: boolean
    vehicleTypes: string[]
    gettingVehicleData: boolean
    selectedVehicle: Vehicle | null
    gettingTestPackages: boolean
    dealerTestPackages: DealerTestPackage[]
    gettingPackageDetail: boolean
    dvsTests: TestDetail[] | null
    gettingCustomers: boolean
    customers: Customer[]
    gettingBookingSlots: boolean
    packageSlots: SchedulerPackageSlot[]
    gettingTestStations: boolean
    testStations: TestStation[]
    gettingBookingStatus: boolean
    bookingStatusList: BookingStatus[]
    gettingTransactionTypes: boolean
    transactionTypes: TransactonType[]
    gettingTestCodes: boolean
    testsData: Test[]
    gettingAxles: boolean
    axlesData: Axles[]
    selectedBookingId: number | null
    showBreakDialog: boolean
    showTestDialog: boolean
    savingBooking: boolean
    loadingAvailabilityInterval: boolean
    dvsaDayAvailability: DVSAAvailability | null
    gettingWeeklyBookings: boolean
    selectedWeeklyDate: Date | null
    selectedPackagePlanner: number
    weeklyBookings: WeeklyBooking[]
    plannerTestPackages: DealerTestPackage[]
    plannerInterval: number
    gettingPlannerTestPackages: boolean
    // selectedMultipleDealer: UserDealer[]
    overviews: Overview[]
    overviewIsLoading: boolean
    feeReportFilters: FeesReportParams
    feeReport: FeesReport[]
    feeReportLoading: boolean
    hasScheduleForDay: boolean
    NewBKStartDate: string | null
    bookingReminder: BookingReminder[]
    bookingReminderLoading: boolean
    testPackagePopupShow: boolean
    hasCustomPrice: boolean
    checkingCustomPrice: boolean
    motCustomPrice: MOTCustomPrice | null
    bookingUdateInfo: Bookingupdateinfo[]
    bookingLogModal: boolean
    dataLogModal: boolean
    downloadloader: boolean
    deleteloader: boolean
    existsloader: boolean
    blobExists: boolean
}

export const bookingInit = () => {
    return {
        bookingID: 0,
        bookingRef: "",
        vehicleID: null,
        dealerID: 0,
        customerID: 0,
        accountNo: "",
        companyName: "",
        testStationID: null,
        jobNumber: "",
        customerOrderRef: "",
        axleCode: "",
        testCode: "",
        testPackageID: null,
        testPackage: null,
        testStart: dayjs().startOf("day").toDate().toString(),
        testEnd: dayjs().startOf("day").toDate().toString(),
        testFee: 0,
        laneFee: 0,
        total: 0,
        notes: "",
        bookingStatusID: null,
        bookingTypeID: 1,
        bookingType: "",
        bookingStatus: "",
        dealerName: "",
        testStationName: "",
        addedBy: "",
        updatedBy: "",
        addedByAppUserID: "",
        addedDate: "",
        updatedByAppUserID: "",
        updatedDate: "",
        recipients: "",
        email: "",
        phone: "",
        registration: "",
        make: "",
        model: "",
        vehicleType: "",
        vehicleClass: "",
        registrationDate: null,
        manufactureDate: null,
        annualTestExpiryDate: null,
        dvsaFetchDate: null,
        customer: null,
        newVehicle: false,
        duration: 0,
        tranType: "",
        reminderCall: false,
        sendReminderEmail: true,
        preparedByDealer: false,
        isBlocked: false,
    } as BookingDetail
}

const initialState: MOTBookingState = {
    gettingBookings: false,
    bookings: [],
    bookingFilters: {
        start: dayjs().toDate(),
        selectedDealer: null,
    },
    overviewFilters: {
        dateRange: {start: dayjs().toDate(), end: dayjs().add(15, "day").toDate()},
        selectedDealer: null,
    },
    loadingBookingDetail: false,
    loadingMakes: false,
    makeList: [],
    loadingModels: false,
    modelsList: [],
    loadingVehicleClass: false,
    vehicleClasses: [],
    loadingVehicleType: false,
    vehicleTypes: [],

    bookingDetail: bookingInit(),
    bookingDetailNoEdit: bookingInit(),
    gettingVehicleData: false,
    selectedVehicle: null,
    gettingTestPackages: false,
    dealerTestPackages: [],
    gettingPackageDetail: false,
    dvsTests: [],
    gettingCustomers: false,
    customers: [],
    gettingBookingSlots: false,
    packageSlots: [],
    gettingTestStations: false,
    testStations: [],
    gettingBookingStatus: false,
    bookingStatusList: [],
    gettingTransactionTypes: false,
    transactionTypes: [],
    gettingAxles: false,
    gettingTestCodes: false,
    axlesData: [],
    testsData: [],
    selectedBookingId: null,
    showBreakDialog: false,
    showTestDialog: false,
    savingBooking: false,
    loadingAvailabilityInterval: false,
    dvsaDayAvailability: null,
    gettingWeeklyBookings: false,
    selectedWeeklyDate: new Date(),
    selectedPackagePlanner: 0,
    weeklyBookings: [],
    plannerTestPackages: [],
    plannerInterval: 60,
    gettingPlannerTestPackages: false,
    overviews: [],
    overviewIsLoading: false,
    feeReportFilters: {
        dateRange: {start: dayjs().toDate(), end: dayjs().toDate()},
        dealerIds: [],
        searchText: "",
    },
    feeReport: [],
    feeReportLoading: false,
    hasScheduleForDay: false,
    NewBKStartDate: dayjs().toDate().toString(),
    bookingReminder: [],
    bookingReminderLoading: false,
    testPackagePopupShow: false,
    hasCustomPrice: false,
    motCustomPrice: null,
    checkingCustomPrice: false,
    bookingUdateInfo: [],
    bookingLogModal: false,
    dataLogModal: false,
    downloadloader: false,
    deleteloader: false,
    existsloader: false,
    blobExists: false,
}

const motbookingSlice = createSlice({
    name: "motbooking",
    initialState,
    reducers: {
        setBookingFilters(state, action: PayloadAction<BookingParams>) {
            state.bookingFilters = action.payload
        },
        setOverviewFilters(state, action: PayloadAction<OverviewParams>) {
            state.overviewFilters = action.payload
        },
        loadingBooking(state, action: PayloadAction<boolean>) {
            state.gettingBookings = action.payload
        },
        setBookingsData(state, action: PayloadAction<Booking[]>) {
            state.bookings = action.payload.map(x => ({...x, bookingDate: x.testStart, total: x.testFee + x.laneFee}))
        },
        loadingBookingDetail(state, action: PayloadAction<boolean>) {
            state.loadingBookingDetail = action.payload
        },
        setNewBookingDetail(state, action: PayloadAction<NewBookingParams>) {
            let bkdata = bookingInit()
            const {
                testStart,
                testEnd,
                dealerId,
                testPackageID,
                registration,
                testFee,
                laneFee,
                duration,
                preparerDealerName,
                preparedByDealer,
            } = action.payload

            if (testPackageID === null || testPackageID === 0) {
                state.dvsTests = []
            }

            // set Default TestStation for dealer
            const defaultTestStation = state.testStations.find(
                (x: TestStation) => x.dealerID === dealerId && x.dealerDefault,
            )
            if (defaultTestStation) {
                bkdata.testStationID = defaultTestStation?.testStationID
                bkdata.testStationName = defaultTestStation?.testStationName
            }
            bkdata.bookingID = 0
            bkdata.dealerID = dealerId
            bkdata.testStart = testStart
            bkdata.testEnd = testEnd
            bkdata.bookingTypeID = 1
            bkdata.testPackageID = testPackageID
            bkdata.registration = registration ?? ""
            bkdata.preparerDealerName = preparerDealerName
            bkdata.preparedByDealer = preparedByDealer
            if (testPackageID !== null && testPackageID > 0) {
                const selectedTestPackage = state.plannerTestPackages.find(x => x.testPackageID === testPackageID)

                bkdata.duration = duration ?? 0
                bkdata.laneFee = laneFee ?? 0
                bkdata.testFee = testFee ?? 0
                bkdata.total = bkdata.testFee + bkdata.laneFee
            }
            state.bookingDetail = bkdata
            // set BookingID = 0 for new bookings
            state.selectedBookingId = 0
        },
        setBookingDetail(state, action: PayloadAction<BookingDetail>) {
            state.bookingDetail = action.payload
        },
        setBookingDetailNoEdit(state, action: PayloadAction<BookingDetail>) {
            state.bookingDetailNoEdit = action.payload
        },
        showCustomPriceForBooking(state, action: PayloadAction<[MOTCustomPrice | null, boolean]>) {
            let bk = state.bookingDetail
            const selectedTestPackage = state.bookingDetail.testPackageID
            // When testpakage is not selected
            if (selectedTestPackage === null) {
                state.bookingDetail = {
                    ...bk,
                    laneFee: 0,
                    total: 0,
                }
            }
            // When Custom Price changes based on attribute, reset thee test package lane fee.
            if (state.hasCustomPrice && state.motCustomPrice !== action.payload[0] && selectedTestPackage) {
                const testPackage = state.dealerTestPackages.find(x => x.testPackageID === selectedTestPackage)
                if (testPackage) {
                    state.bookingDetail = {
                        ...bk,
                        laneFee: testPackage.laneFee ?? 0,
                        total: bk.testFee + testPackage.laneFee ?? 0,
                    }
                }
            }

            state.motCustomPrice = action.payload[0]
            state.hasCustomPrice = action.payload[1]
            state.checkingCustomPrice = false
            // When Custom Price not found, reset thee test package lane fee.
            if (!action.payload[1] && selectedTestPackage && selectedTestPackage > 0) {
                const checktestPackage = state.dealerTestPackages.find(x => x.testPackageID === selectedTestPackage)
                let bk = state.bookingDetail
                if (checktestPackage) {
                    // let laneFee = bk.laneFee !== testPackage.laneFee ? bk.laneFee : testPackage.laneFee
                    state.bookingDetail = {
                        ...bk,
                        laneFee: checktestPackage.laneFee ?? 0,
                        total: bk.testFee + checktestPackage.laneFee ?? 0,
                    }
                }
            }
        },
        updateLaneFeesForBooking(state, action: PayloadAction<number>) {
            let bk = state.bookingDetail
            const laneFee = action.payload
            state.bookingDetail = {...bk, laneFee: laneFee, total: bk.testFee + laneFee, cpApplied: true}
        },

        setMakesData(state, action: PayloadAction<[boolean, string[]]>) {
            state.loadingMakes = action.payload[0]
            state.makeList = action.payload[1]
        },
        setMakeModelsData(state, action: PayloadAction<[boolean, string[]]>) {
            state.loadingModels = action.payload[0]
            state.modelsList = action.payload[1]
        },
        setVehicleClassesData(state, action: PayloadAction<[boolean, string[]]>) {
            state.loadingMakes = action.payload[0]
            state.vehicleClasses = action.payload[1]
        },
        setVehicleTypesData(state, action: PayloadAction<[boolean, string[]]>) {
            state.loadingModels = action.payload[0]
            state.vehicleTypes = action.payload[1]
        },
        loadingVehiclesData(state, action: PayloadAction<boolean>) {
            state.gettingVehicleData = action.payload
        },
        loadingDealerTestPackages(state, action: PayloadAction<boolean>) {
            state.gettingTestPackages = action.payload
        },
        setDealerTestPackages(state, action: PayloadAction<DealerTestPackage[]>) {
            let testPackages = action.payload

            if (testPackages.length > 0) {
                testPackages = testPackages.map(x => {
                    return {...x, laneFee: x.laneFee ?? 0, testFee: x.testFee}
                })
            }
            state.dealerTestPackages = testPackages
        },

        loadingPackageDetails(state, action: PayloadAction<boolean>) {
            state.gettingPackageDetail = action.payload
        },
        setTestsData(state, action: PayloadAction<TestDetail[]>) {
            state.dvsTests = action.payload
        },

        loadingCustomers(state, action: PayloadAction<boolean>) {
            state.gettingCustomers = action.payload
        },
        setCustomers(state, action: PayloadAction<Customer[]>) {
            state.customers = action.payload
        },
        loadingBookingSlots(state, action: PayloadAction<boolean>) {
            state.gettingBookingSlots = action.payload
        },
        setPackageSlots(state, action: PayloadAction<SchedulerPackageSlot[]>) {
            state.packageSlots = action.payload
        },
        loadingTestStations(state, action: PayloadAction<boolean>) {
            state.gettingTestStations = action.payload
        },
        setTestStations(state, action: PayloadAction<TestStation[]>) {
            state.testStations = action.payload
        },
        loadingBookingStatus(state, action: PayloadAction<boolean>) {
            state.gettingBookingStatus = action.payload
        },
        setBookingStatus(state, action: PayloadAction<BookingStatus[]>) {
            state.bookingStatusList = action.payload
        },
        loadingTransactionTypes(state, action: PayloadAction<boolean>) {
            state.gettingTransactionTypes = action.payload
        },
        setTransactionTypes(state, action: PayloadAction<TransactonType[]>) {
            state.transactionTypes = action.payload
        },
        loadingAxles(state, action: PayloadAction<boolean>) {
            state.gettingAxles = action.payload
        },
        loadingTestCodes(state, action: PayloadAction<boolean>) {
            state.gettingTestCodes = action.payload
        },
        setAxlesData(state, action: PayloadAction<Axles[]>) {
            state.axlesData = action.payload
        },
        setTestCodes(state, action: PayloadAction<Test[]>) {
            state.testsData = action.payload
        },
        loadingWeeklyBooking(state, action: PayloadAction<boolean>) {
            state.gettingWeeklyBookings = action.payload
            if (action.payload) {
                state.weeklyBookings = []
            }
        },
        setWeeklyDate(state, action: PayloadAction<Date>) {
            state.selectedWeeklyDate = action.payload
        },
        setPlannerTestPackge(state, action: PayloadAction<number>) {
            state.selectedPackagePlanner = action.payload
        },
        setWeeklyBookingsData(state, action: PayloadAction<WeeklyBooking[]>) {
            state.weeklyBookings = action.payload
        },
        setSelectedBookingId(state, action: PayloadAction<number>) {
            state.selectedBookingId = action.payload
        },
        toggleTestDialog(state, action: PayloadAction<boolean>) {
            state.showTestDialog = action.payload
            if (!action.payload) {
                state.selectedBookingId = null
                //Uncomment the line below to call Schedules for validation on opening  for datepicker.
                state.bookingDetail.dealerID = 0
            }
        },
        toggleBreakDialog(state, action: PayloadAction<boolean>) {
            state.showBreakDialog = action.payload
            if (!action.payload) {
                state.selectedBookingId = null
            }
        },
        savingBookingData(state, action: PayloadAction<boolean>) {
            state.savingBooking = action.payload
        },
        setLoadingAvailabilityInterval(state, action: PayloadAction<boolean>) {
            state.loadingAvailabilityInterval = action.payload
        },
        setAvailabilityInterval(state, action: PayloadAction<DVSAAvailability | null>) {
            state.dvsaDayAvailability = action.payload
        },
        setPlannerTestPackages(state, action: PayloadAction<[boolean, DealerTestPackage[]]>) {
            state.gettingPlannerTestPackages = action.payload[0]
            state.plannerTestPackages = action.payload[1]
        },
        setPlannerInterval(state, action: PayloadAction<number>) {
            state.plannerInterval = action.payload
        },
        setOverviews(state, action: PayloadAction<Overview[]>) {
            state.overviews = action.payload
        },
        setOverviewLoading(state, action: PayloadAction<boolean>) {
            state.overviewIsLoading = action.payload
        },
        setFeeReportFilter(state, action: PayloadAction<FeesReportParams>) {
            state.feeReportFilters = action.payload
        },
        setFeeReportData(state, action: PayloadAction<FeesReport[]>) {
            state.feeReport = action.payload.map(x => ({...x, total: x.testFee + x.laneFee}))
        },
        setFeeReportLoader(state, action: PayloadAction<boolean>) {
            state.feeReportLoading = action.payload
        },
        setScheduleForDay(state, action: PayloadAction<boolean>) {
            state.hasScheduleForDay = action.payload
        },
        setTestPackagePopupShow(state, action: PayloadAction<boolean>) {
            state.testPackagePopupShow = action.payload
        },
        setNewBKStartDate(state, action: PayloadAction<string | null>) {
            state.NewBKStartDate = action.payload
        },
        getBookingReminder(state, action: PayloadAction<BookingReminder[]>) {
            state.bookingReminder = action.payload
        },
        getBookingUpdateInfo(state, action: PayloadAction<Bookingupdateinfo[]>) {
            state.bookingUdateInfo = action.payload
        },
        setBookingReminderLoading(state, action: PayloadAction<boolean>) {
            state.bookingReminderLoading = action.payload
        },
        showBookingLogModal(state, action: PayloadAction<boolean>) {
            state.bookingLogModal = action.payload
        },
        showDataLogModal(state, action: PayloadAction<boolean>) {
            state.dataLogModal = action.payload
        },
        showDownloadLoader(state, action: PayloadAction<boolean>) {
            state.downloadloader = action.payload
        },
        showDeleteLoader(state, action: PayloadAction<boolean>) {
            state.deleteloader = action.payload
        },
        setExistsLoader(state, action: PayloadAction<boolean>) {
            state.existsloader = action.payload
        },
        setBlobExists(state, action: PayloadAction<boolean>) {
            state.blobExists = action.payload
        },
        setCheckingCustomPrice(state, action: PayloadAction<boolean>) {
            state.checkingCustomPrice = action.payload
        },
        setPrepareByDealerId(state, action: PayloadAction<boolean>) {
            state.bookingDetail = {...state.bookingDetail, preparedByDealer: action.payload}
        },
    },
})

export const {
    setBookingFilters,
    setOverviewFilters,
    loadingBooking,
    setBookingsData,
    loadingBookingDetail,
    setNewBookingDetail,
    setBookingDetail,
    setMakesData,
    setMakeModelsData,
    setVehicleClassesData,
    setVehicleTypesData,
    loadingVehiclesData,
    loadingDealerTestPackages,
    loadingPackageDetails,
    setDealerTestPackages,
    setTestsData,
    loadingCustomers,
    setCustomers,
    loadingBookingSlots,
    setPackageSlots,
    loadingTestStations,
    setTestStations,
    loadingBookingStatus,
    setBookingStatus,
    loadingTransactionTypes,
    setTransactionTypes,
    loadingAxles,
    loadingTestCodes,
    setAxlesData,
    setTestCodes,
    loadingWeeklyBooking,
    setWeeklyDate,
    setPlannerTestPackge,
    setWeeklyBookingsData,
    setSelectedBookingId,
    toggleTestDialog,
    toggleBreakDialog,
    savingBookingData,
    setLoadingAvailabilityInterval,
    setAvailabilityInterval,
    setPlannerTestPackages,
    setPlannerInterval,
    setOverviews,
    setOverviewLoading,
    setFeeReportFilter,
    setFeeReportData,
    setFeeReportLoader,
    setScheduleForDay,
    setNewBKStartDate,
    getBookingReminder,
    setBookingReminderLoading,
    setTestPackagePopupShow,
    showCustomPriceForBooking,
    updateLaneFeesForBooking,
    getBookingUpdateInfo,
    showBookingLogModal,
    showDataLogModal,
    setBookingDetailNoEdit,
    showDownloadLoader,
    showDeleteLoader,
    setExistsLoader,
    setBlobExists,
    setCheckingCustomPrice,
    setPrepareByDealerId,
} = motbookingSlice.actions

export default motbookingSlice.reducer

export const setBookingFiltersAction =
    (data: BookingParams): AppThunk =>
    dispatch => {
        dispatch(setBookingFilters(data))
    }

const getStartDay = (date = new Date()) => dayjs(date).startOf("day")

const getEndDay = (date = new Date()) => dayjs(date).endOf("day")

// GRID DATA
export const fetchBookingsDataAction =
    (param: BookingParams): AppThunk =>
    (dispatch: any, getState) => {
        const regionId = getSelectedRegionId(getState())
        dispatch(loadingBooking(true))

        const dealerId = param.selectedDealer === null ? 0 : param.selectedDealer.dealerId
        const startDate = dayjs(param.start).startOf("day").format("YYYY-MM-DDTHH:mm:ss")

        httpService(getAccessToken(getState()))
            .get(`regions/${regionId}/bookings?fromDate=${startDate}&dealerId=${dealerId}`)
            .then(res => {
                const formatAsDate = (dateColumn: Date | null) =>
                    dateColumn !== null ? dayjs(dateColumn).toDate() : null
                const gridData = res.data.item1.map((d: any) => ({
                    ...d,
                    reminderCall:
                        d.bookingTypeID === 1 && (d.reminderCall ?? false)
                            ? "Called"
                            : d.bookingTypeID === 1 &&
                              (!d.reminderCall ?? false) &&
                              dayjs(d.testStart).diff(dayjs().startOf("day"), "hour") > 0
                            ? "Pending"
                            : "",
                    testStart: formatAsDate(d.testStart),
                    testStartTime: d.testStart,
                }))
                dispatch(setBookingsData(gridData))
                dispatch(setOverviews(res.data.item2))
                dispatch(loadingBooking(false))
            })
            .catch(error => {
                dispatch(setBookingsData([]))
                dispatch(setOverviews([]))
                dispatch(loadingBooking(false))
            })
        // }
    }
// FETCH Booking Details
export const fetchBookingDetail =
    (bookingID: number): AppThunk =>
    (dispatch: any, getState) => {
        dispatch(loadingBookingDetail(true))
        const regionId = getSelectedRegionId(getState())
        if (bookingID > 0) {
            httpService(getAccessToken(getState()))
                .get(`regions/${regionId}/booking/${bookingID}`)
                .then(res => {
                    let b = res.data as BookingDetail
                    b.duration = 0
                    b.customer = {} as Customer
                    if (b.customerID > 0) {
                        b.customer.customerId = b.customerID
                        b.customer.companyName = b.companyName
                        b.customer.accountNo = b.accountNo
                        b.customer.displayName = b.accountNo + " - " + b.companyName
                    } else {
                        b.customer.companyName = b.companyName
                        b.customer.displayName = b.companyName
                    }
                    b.axleCode = b.axleCode ?? ""
                    b.testCode = b.testCode ?? ""
                    dispatch(setBookingDetail(b))
                    dispatch(setBookingDetailNoEdit(b))
                    dispatch(loadingBookingDetail(false))
                })
                .catch(error => {
                    dispatch(setBookingDetail(bookingInit()))
                    dispatch(loadingBookingDetail(false))
                })
        } else {
            dispatch(loadingBookingDetail(false))
        }
    }

export const resetBookingVehicleSection =
    (booking: BookingDetail): AppThunk =>
    (dispatch: any) => {
        const preserveTestInformation = booking.testPackageID !== null && booking.testPackageID > 0
        const resetVehicleInfo = {
            ...booking,
            vehicleID: null,
            registration: "",
            make: "",
            model: "",
            vehicleType: "",
            vehicleClass: "",
            manufactureDate: null,
            annualTestExpiryDate: null,
            registrationDate: null,
            dvsaFetchDate: null,
            newVehicle: false,
            testCode: preserveTestInformation ? booking.testCode ?? "" : "",
            axleCode: preserveTestInformation ? booking.axleCode ?? "" : "",
            testPackageID: preserveTestInformation ? booking.testPackageID : null,
            laneFee: preserveTestInformation ? booking.laneFee : 0,
            testFee: preserveTestInformation ? booking.testFee : 0,
            total: preserveTestInformation ? booking.testFee + booking.laneFee : 0,
            annualTests: null,
        } as BookingDetail
        dispatch(setBookingDetail(resetVehicleInfo))
    }

// FETCH VEHICLES DATA NY REG NO
export const fetchVehicleData =
    (vehicleRegNo: string, booking: BookingDetail): AppThunk =>
    (dispatch: any, getState) => {
        dispatch(setBookingDetail({...booking, registration: vehicleRegNo}))
        dispatch(loadingVehiclesData(true))
        const preserveTestInformation = booking.testPackageID !== null && booking.testPackageID > 0

        httpService(getAccessToken(getState()))
            .get(`vehicles/search/${vehicleRegNo}?includeAxle=true`)
            .then(res => {
                const v = res.data as Vehicle
                const bookingData = {
                    ...booking,
                    vehicleID: v.vehicleId,
                    registration: v.registration ?? vehicleRegNo,
                    make: v.make ?? "",
                    model: v.model ?? "",
                    // Preserve user's vehicleType selection if vehicle already has DVSA data, otherwise use DVSA value
                    vehicleType: booking.dvsaFetchDate !== null && booking.vehicleType ? booking.vehicleType : (v.vehicleType ?? ""),
                    vehicleClass: v.vehicleClass ?? "",
                    manufactureDate: v.manufactureDate,
                    annualTestExpiryDate: v.annualTestExpiryDate,
                    registrationDate: v.registrationDate,
                    dvsaFetchDate: v.dvsaFetchDate,
                    newVehicle: v.vehicleId === 0,
                    testCode: preserveTestInformation
                        ? booking.testCode
                        : selectTestCodeByVehicleType(booking.dvsaFetchDate !== null && booking.vehicleType ? booking.vehicleType : (v.vehicleType ?? "")),
                    axleCode: preserveTestInformation ? booking.axleCode : v.axleCode,
                    testPackageID: preserveTestInformation ? booking.testPackageID : null,
                    annualTests: v.annualTests
                        ?.sort((a, b) => {
                            if (
                                (a.testResult === "PASSED" && b.testResult !== "PASSED") ||
                                (a.testResult === "FAILED" && b.testResult !== "FAILED")
                            )
                                return -1
                            else if (
                                (a.testResult !== "PASSED" && b.testResult === "PASSED") ||
                                (a.testResult !== "FAILED" && b.testResult === "FAILED")
                            )
                                return 1
                            return 0
                        })
                        .filter(
                            annualTest =>
                                annualTest.testDate.split("T")[0] ===
                                dayjs(getState().containers.motBooking.bookingDetail.testStart)
                                    .startOf("date")
                                    .format("YYYY-MM-DD"),
                        ),
                } as BookingDetail
                bookingData.vehicleID === 0 &&
                    dispatch(
                        setToastr({
                            isActive: true,
                            message: "Vehicle unavailable in DVSA",
                            delay: 3000,
                            title: "Error",
                            type: "danger",
                            description: "",
                        }),
                    )

                dispatch(setBookingDetail(bookingData))

                dispatch(loadingVehiclesData(false))
            })
            .catch(error => {
                dispatch(loadingVehiclesData(false))
            })
    }

export const fetchMakeData = (): AppThunk => (dispatch: any, getState) => {
    dispatch(setMakesData([true, []]))
    httpService(getAccessToken(getState()))
        .get(`vehicles/make`)
        .then(res => {
            const makeList = res.data as string[]
            dispatch(setMakesData([false, makeList]))
        })
        .catch(error => {
            dispatch(setMakesData([false, []]))
        })
}

export const fetchModelData =
    (make: string): AppThunk =>
    (dispatch: any, getState) => {
        dispatch(setMakeModelsData([true, []]))
        httpService(getAccessToken(getState()))
            .get(`vehicles/model?make=${make}`)
            .then(res => {
                const modelList = res.data as string[]
                dispatch(setMakeModelsData([false, modelList]))
            })
            .catch(error => {
                dispatch(setMakeModelsData([false, []]))
            })
    }

export const fetchVehicleClassesData = (): AppThunk => (dispatch: any, getState) => {
    dispatch(setVehicleClassesData([true, []]))
    httpService(getAccessToken(getState()))
        .get(`vehicles/vehicleclass`)
        .then(res => {
            const classList = res.data as string[]
            dispatch(setVehicleClassesData([false, classList]))
        })
        .catch(error => {
            dispatch(setVehicleClassesData([false, []]))
        })
}

export const fetchVehicleTypesData = (): AppThunk => (dispatch: any, getState) => {
    dispatch(setVehicleTypesData([true, []]))
    httpService(getAccessToken(getState()))
        .get(`vehicles/vehicleType`)
        .then(res => {
            const vehicleTypeList = res.data as string[]
            dispatch(setVehicleTypesData([false, vehicleTypeList]))
        })
        .catch(error => {
            dispatch(setVehicleTypesData([false, []]))
        })
}

// FETCH Test Packages
export const fetchTestPackages =
    (selectedDealerId: number, axleCode: string, testCode: string, testStart: string): AppThunk =>
    (dispatch: any, getState) => {
        dispatch(loadingDealerTestPackages(true))
        httpService(getAccessToken(getState()))
            .get(
                `regions/${getSelectedRegionId(
                    getState(),
                )}/dealers/${selectedDealerId}/testPackageByCodes?axleCode=${axleCode}&testCode=${testCode}&bkDate=${testStart}`,
            )
            .then(res => {
                dispatch(loadingDealerTestPackages(false))
                dispatch(setDealerTestPackages(res.data))
            })
            .catch(error => {
                dispatch(loadingDealerTestPackages(false))
                dispatch(setDealerTestPackages([]))
            })
    }

// FETCH Customers
export const fetchCustomers =
    (searchText: string): AppThunk =>
    (dispatch: any, getState) => {
        dispatch(loadingCustomers(true))

        httpService(getAccessToken(getState()))
            .get(
                `regions/${getSelectedRegionId(getState())}/customers/shortsearch?searchtext=${encodeURIComponent(
                    searchText,
                )}`,
            )
            .then(res => {
                dispatch(loadingCustomers(false))
                let customers = res.data as Customer[]
                const customerData = customers.map((x: Customer) => {
                    return {...x, displayName: x.accountNo + " - " + x.companyName}
                })
                dispatch(setCustomers(customerData))
            })
            .catch(error => {
                dispatch(loadingCustomers(false))
                dispatch(setCustomers([]))
            })
    }

export const fetchCustomerContactReminderList =
    (booking: BookingDetail, customerId: number): AppThunk =>
    (dispatch: any, getState) => {
        dispatch(loadingCustomers(true))
        httpService(getAccessToken(getState()))
            .get(`regions/${getSelectedRegionId(getState())}/customers/${customerId}/customercontacts/reminderemail`)
            .then(res => {
                dispatch(loadingCustomers(false))
                if (res.data !== "") {
                    const contact = res.data
                    const bookingData = {
                        ...booking,
                        recipients: contact.recipients,
                        email: contact.email,
                        phone: contact.phone,
                    } as BookingDetail
                    dispatch(setBookingDetail(bookingData))
                }
            })
            .catch(error => {
                dispatch(loadingCustomers(false))
                dispatch(setCustomers([]))
            })
    }

// FETCH Test Packages
export const fetchPackageSlots =
    (regionId: number, dealerId: number, testPackageId: number, testDate: string): AppThunk =>
    (dispatch: any, getState) => {
        dispatch(loadingBookingSlots(true))
        httpService(getAccessToken(getState()))
            .get(`regions/${regionId}/dealers/${dealerId}/testPackages/${testPackageId}/slots?testdate=${testDate}`)
            .then(res => {
                dispatch(
                    setPackageSlots(
                        res.data.map((slot: any) => {
                            return {
                                ...slot,
                                id: crypto.randomUUID(),
                                bookingId: slot.bookingId,
                                testStart: new Date(new Date(slot.testStart).toISOString()),
                                testEnd: new Date(new Date(slot.testEnd).toISOString()),
                                testPackageId: slot.testPackageId,
                                testFee: slot.testFee,
                                laneFee: slot.laneFee,
                                duration: slot.duration,
                            }
                        }),
                    ),
                )
                dispatch(loadingBookingSlots(false))
            })
            .catch(() => {
                dispatch(setPackageSlots([]))
                dispatch(loadingBookingSlots(false))
            })
    }
// Fetch Axles
export const fetchAxles = (): AppThunk => (dispatch: any, getState) => {
    dispatch(loadingAxles(true))
    httpService(getAccessToken(getState()))
        .get(`dvsa/axles`)
        .then(res => {
            dispatch(loadingAxles(false))
            dispatch(setAxlesData(res.data))
        })
        .catch(error => {
            dispatch(loadingAxles(false))
        })
}

//Fetch tests
export const fetchTests = (): AppThunk => (dispatch: any, getState) => {
    dispatch(loadingTestCodes(true))
    httpService(getAccessToken(getState()))
        .get(`dvsa/tests`)
        .then(res => {
            dispatch(loadingTestCodes(false))
            dispatch(setTestCodes(res.data))
        })
        .catch(error => {
            dispatch(loadingTestCodes(false))
            dispatch(setTestCodes([]))
        })
}

// FETCH Test Package Details
export const fetchPackageDetails =
    (selectedDealerId: number, testPackageId: number): AppThunk =>
    (dispatch: any, getState) => {
        if (testPackageId > 0) {
            dispatch(loadingPackageDetails(true))
            dispatch(setTestsData([]))
            httpService(getAccessToken(getState()))
                .get(
                    `regions/${getSelectedRegionId(
                        getState(),
                    )}/dealers/${selectedDealerId}/testpackages/${testPackageId}`,
                )
                .then(res => {
                    const testPackageDetails = res.data as TestPackageDetail
                    dispatch(loadingPackageDetails(false))
                    dispatch(setTestsData(testPackageDetails.tests))
                })
                .catch(error => {
                    dispatch(loadingDealerTestPackages(false))
                    dispatch(setTestsData([]))
                })
        }
    }

// FETCH Test Packages
export const fetchTestStations = (): AppThunk => (dispatch: any, getState) => {
    dispatch(loadingTestStations(true))
    httpService(getAccessToken(getState()))
        .get(`regions/${getSelectedRegionId(getState())}/teststations`)
        .then(res => {
            const teststations = res.data as TestStation[]
            dispatch(loadingTestStations(false))
            dispatch(setTestStations(teststations))
        })
        .catch(error => {
            dispatch(loadingTestStations(false))
            dispatch(setTestStations([]))
        })
}

// FETCH Booking Status
export const fetchBookingStatus = (): AppThunk => (dispatch: any, getState) => {
    dispatch(loadingBookingStatus(true))
    httpService(getAccessToken(getState()))
        .get(`vehicles/bookingstatus`)
        .then(res => {
            const bookingStatus = res.data as BookingStatus[]
            dispatch(loadingBookingStatus(false))
            dispatch(setBookingStatus(bookingStatus))
        })
        .catch(error => {
            dispatch(loadingBookingStatus(false))
        })
}

// FETCH TransactionTypes
export const fetchTransactionTypes = (): AppThunk => (dispatch: any, getState) => {
    dispatch(loadingTransactionTypes(true))
    httpService(getAccessToken(getState()))
        .get(`trantypes`)
        .then(res => {
            let transactionTypes = res.data as TransactonType[]
            dispatch(setTransactionTypes(transactionTypes))
        })
        .catch(error => {})
        .finally(() => {
            dispatch(loadingTransactionTypes(false))
        })
}

// Fetch TestDateAVailability
export const fetchDVSAAvailability =
    (dealerId: number, date: string): AppThunk =>
    (dispatch: any, getState) => {
        const regionId = getState().application.selectedRegion.regionId
        const testDate = dayjs(date).format("YYYY-MM-DD")
        dispatch(setLoadingAvailabilityInterval(true))
        httpService(getAccessToken(getState()))
            .get(`regions/${regionId}/dealers/${dealerId}/getDayAvailabilityInterval?date=${testDate}`)
            .then(res => {
                if (res.data !== "") {
                    let interval = {} as DVSAAvailability
                    interval.start = dayjs(res.data.start).toDate()
                    interval.end = dayjs(res.data.end).toDate()
                    dispatch(setAvailabilityInterval(interval))
                } else {
                    dispatch(setAvailabilityInterval(null))
                }
                dispatch(setLoadingAvailabilityInterval(false))
            })
            .catch(error => {
                dispatch(setAvailabilityInterval(null))
                dispatch(setLoadingAvailabilityInterval(false))
            })
    }

// Save Booking Information

export const saveBookingDetails =
    (data: BookingDetail, closePopup: boolean, currentPath: string): AppThunk =>
    async (dispatch: any, getState) => {
        dispatch(savingBookingData(true))
        let booking = {
            ...data,
            annualTests: data.annualTests?.map(test => ({
                ...test,
                defects: test.defects?.map(({failureReason, ...defect}) => defect),
            })),
            testStart: dayjs(data.testStart).format("YYYY-MM-DDTHH:mm:ss"),
            testEnd: dayjs(data.testEnd).format("YYYY-MM-DDTHH:mm:ss"),
            customerID: data.customerID === 0 ? null : data.customerID,
            addedDate: data.bookingID === 0 ? null : data.addedDate,
            updatedDate: null,
            testFee: data.testFee ?? 0,
            laneFee: data.laneFee ?? 0,
        }

        // New Vehicle OR Vehicle information Edited (including DVSA vehicles with user modifications)
        if (booking.newVehicle || (booking?.vehicleID && booking?.vehicleID > 0)) {
            let v = {} as Vehicle
            v.vehicleId = booking.vehicleID ?? 0
            v.registration = booking.registration
            v.make = booking.make
            v.model = booking.model ?? ""
            v.vehicleType = booking.vehicleType ?? ""
            v.vehicleClass = booking.vehicleClass ?? ""
            v.manufactureDate =
                booking.manufactureDate != null ? dayjs(booking.manufactureDate).format("YYYY-MM-DDTHH:mm:ss") : null
            v.annualTestExpiryDate =
                booking.annualTestExpiryDate != null
                    ? dayjs(booking.annualTestExpiryDate).format("YYYY-MM-DDTHH:mm:ss")
                    : null
            v.registrationDate =
                booking.registrationDate != null ? dayjs(booking.registrationDate).format("YYYY-MM-DDTHH:mm:ss") : null

            if (booking.newVehicle) {
                let response = await httpService(getAccessToken(getState())).post(`vehicles`, v)
                if (response.data > 0) booking.vehicleID = response.data
            }
            if (booking?.vehicleID && booking?.vehicleID > 0) {
                 await httpService(getAccessToken(getState())).put(`vehicles/${booking.vehicleID}`, v)
            }
        }

        // preparerID
        //BUG 1133085 - FIX - BEGIN
        booking = {
            ...booking,
            preparerDealerName: booking.preparerDealerName,
            preparerID:
                booking.preparerID === null || booking.preparerID === undefined
                    ? getState()
                          .application.userDealers.filter(x => x.dealerId)
                          .find(x => x.dealerName === data.preparerDealerName)?.preparerId
                    : booking.preparerID,
        }
        //BUG 1133085 - FIX - END

        if (booking.bookingID > 0) {
            httpService(getAccessToken(getState()))
                .put(`regions/${getSelectedRegionId(getState())}/booking/${booking.bookingID}`, booking)
                .then((res: any) => {
                    dispatch(
                        setToastr({
                            isActive: true,
                            message: "Booking details saved",
                            delay: 3000,
                            title: "Success",
                            type: "light",
                            description: "",
                        }),
                        dispatch(afterBookingSaved(closePopup, currentPath, booking.bookingID)),
                    )
                })
                .catch((err: any) => {
                    let error = err.response?.data.Value as ErrorMessage

                    dispatch(
                        setToastr({
                            isActive: true,
                            message: error.Error,
                            delay: 3000,
                            title: "Error",
                            type: "danger",
                            description: error.Description,
                        }),
                    )
                    dispatch(afterBookingSaved(closePopup, currentPath, booking.bookingID))
                })
        } else {
            httpService(getAccessToken(getState()))
                .post(`regions/${getSelectedRegionId(getState())}/booking`, booking)
                .then((res: any) => {
                    let bookingID = res.data
                    dispatch(
                        setToastr({
                            isActive: true,
                            message: "Booking details saved",
                            delay: 3000,
                            title: "Success",
                            type: "light",
                            description: "",
                        }),
                    )
                    dispatch(afterBookingSaved(closePopup, currentPath, bookingID))
                })
                .catch((err: any) => {
                    let error = err.response?.data.Value as ErrorMessage

                    dispatch(
                        setToastr({
                            isActive: true,
                            message: error.Error,
                            delay: 3000,
                            title: "Error",
                            type: "danger",
                            description: error.Description,
                        }),
                    )
                    dispatch(afterBookingSaved(closePopup, currentPath, booking.bookingID))
                })
        }
    }

const afterBookingSaved =
    (closePopup: boolean, currentPath: string, bookingId: number | null = null): AppThunk =>
    (dispatch: any, getState) => {
        const bookingFilters = getState().containers.motBooking.bookingFilters
        const selectedDealer = getState().application.selectedSingleDealer
        dispatch(savingBookingData(false))

        if (closePopup) {
            dispatch(toggleTestDialog(false))
            dispatch(toggleBreakDialog(false))
        } else {
            if (bookingId && bookingId >= 0) dispatch(fetchBookingDetail(bookingId))
        }

        if (currentPath.includes("/mot-bookings")) {
            dispatch(
                fetchBookingsDataAction({
                    start: bookingFilters.start,
                    selectedDealer: selectedDealer,
                }),
            )
        }
        if (currentPath.includes("/planner")) {
            const weeklyDate = getState().containers.motBooking.selectedWeeklyDate
            const selectedDate = dayjs(weeklyDate ?? new Date()).format("YYYY-MM-DD")
            const selectedPackagePlanner = getState().containers.motBooking.selectedPackagePlanner
            dispatch(fetchPlannerDataAction(selectedDate, selectedPackagePlanner))
        }
        if (currentPath.includes("/overview")) {
            const overviewFilter = getState().containers.motBooking.overviewFilters
            dispatch(fetchOverview(overviewFilter))
        }
        if (currentPath.includes("/reports")) {
            const dealerIds = getState().application.selectedMultipleDealer
            const feeReportParam = {...getState().containers.motBooking.feeReportFilters, dealerIds} as FeesReportParams
            dispatch(fetchFeesReport(feeReportParam))
        }
        if (currentPath.includes("/activities")) {
            dispatch(fetchBookingReminder(getState().application.selectedSingleDealer?.dealerId))
        }
    }

export const sendEmailReminderCall =
    (bookingId: number, sendEmailReminder: boolean, currentPath: string): AppThunk =>
    async (dispatch: any, getState) => {
        dispatch(savingBookingData(true))
        httpService(getAccessToken(getState()))
            .put(`regions/${getSelectedRegionId(getState())}/booking/${bookingId}/email-reminder`)
            .then(res => {
                dispatch(fetchBookingDetail(bookingId))
                dispatch(
                    setToastr({
                        isActive: true,
                        message: `Email reminder ${res.data == null ? "failed" : res.data ? "enabled" : "disabled"}`,
                        delay: 3000,
                        title: "Success",
                        type: "light",
                        description: "",
                    }),
                )
                dispatch(afterBookingSaved(false, currentPath, bookingId))
            })
            .catch(error => dispatch(savingBookingData(false)))
    }

export const sendReminderCall =
    (bookingId: number, reminderCall: boolean, currentPath: string): AppThunk =>
    async (dispatch: any, getState) => {
        dispatch(savingBookingData(true))
        httpService(getAccessToken(getState()))
            .put(`regions/${getSelectedRegionId(getState())}/booking/${bookingId}/reminder`)
            .then(res => {
                dispatch(fetchBookingDetail(bookingId))
                dispatch(
                    setToastr({
                        isActive: true,
                        message: `Reminder call ${res.data == null ? "failed" : res.data ? "sent" : "updated"} `,
                        delay: 3000,
                        title: "Success",
                        type: "light",
                        description: "",
                    }),
                )
                dispatch(afterBookingSaved(false, currentPath, bookingId))
            })
            .catch(err => dispatch(savingBookingData(false)))
    }

export const sendConfirmationEmail =
    (bookingId: number, currentPath: string): AppThunk =>
    async (dispatch: any, getState) => {
        dispatch(savingBookingData(true))
        httpService(getAccessToken(getState()))
            .put(`regions/${getSelectedRegionId(getState())}/booking/${bookingId}/confirmationmail`)
            .then(res => {
                dispatch(
                    setToastr({
                        isActive: true,
                        message: "Confirmation email sent",
                        delay: 3000,
                        title: "Success",
                        type: "light",
                        description: "",
                    }),
                )
                dispatch(fetchBookingDetail(bookingId))
                dispatch(afterBookingSaved(false, currentPath, bookingId))
            })
            .catch(error => dispatch(savingBookingData(false)))
    }

export const reminderEmailSent =
    (bookingId: number, currentPath: string): AppThunk =>
    async (dispatch: any, getState) => {
        dispatch(savingBookingData(true))
        httpService(getAccessToken(getState()))
            .put(`regions/${getSelectedRegionId(getState())}/booking/${bookingId}/remindermail`)
            .then(res => {
                dispatch(
                    setToastr({
                        isActive: true,
                        message: "Reminder email Sent",
                        delay: 3000,
                        title: "Success",
                        type: "light",
                        description: "",
                    }),
                )
                dispatch(fetchBookingDetail(bookingId))
                dispatch(afterBookingSaved(false, currentPath, bookingId))
            })
            .catch(error => dispatch(savingBookingData(false)))
    }

export const getCustomPriceForBooking =
    (bookingDate: string, dealerId: number, customerId: number, testPackageID: number, bookingID: number): AppThunk =>
    async (dispatch: any, getState) => {
        dispatch(setCheckingCustomPrice(true))

        httpService(getAccessToken(getState()))
            .get(
                `regions/${getSelectedRegionId(
                    getState(),
                )}/dealers/${dealerId}/getcustompriceforbooking?bookingDate=${bookingDate}&customerId=${customerId}&testpackageId=${testPackageID}`,
            )
            .then(res => {
                if (res.data !== "") {
                    const customPrice = res.data as MOTCustomPrice
                    dispatch(showCustomPriceForBooking([customPrice, true]))
                    if (bookingID === 0) {
                        dispatch(updateLaneFeesForBooking(customPrice.value))
                    }
                } else {
                    dispatch(showCustomPriceForBooking([null, false]))
                }
            })
            .catch(error => {})
    }

// Planner Actions
// Fetch Planner Data
export const fetchPlannerDataAction =
    (date: string, testPackageId: number | null): AppThunk =>
    (dispatch: any, getState) => {
        const regionId = getState().application.selectedRegion.regionId
        const dealerId = getState().application.selectedSingleDealer?.dealerId || 0

        dispatch(loadingWeeklyBooking(true))

        httpService(getAccessToken(getState()))
            .get(`regions/${regionId}/dealer/${dealerId}/planner?date=${date}&testPackageId=${testPackageId}`)
            .then(res => dispatch(setWeeklyBookingsData(res.data)))
            .catch(error => dispatch(setWeeklyBookingsData([])))
            .finally(() => dispatch(loadingWeeklyBooking(false)))
    }

// FETCH Test Packages By Dealer
export const fetchPlannerTestPackages =
    (selectedDealerId: number, weeklyDate: string): AppThunk =>
    (dispatch: any, getState) => {
        dispatch(setPlannerTestPackages([true, []]))
        httpService(getAccessToken(getState()))
            .get(
                `regions/${getSelectedRegionId(
                    getState(),
                )}/dealers/${selectedDealerId}/testPackageByCodes?bkDate=${weeklyDate}`,
            )
            .then(res => {
                const plannerTestPackages = res.data as DealerTestPackage[]
                dispatch(setPlannerTestPackages([false, plannerTestPackages]))
            })
            .catch(error => {
                dispatch(setPlannerTestPackages([false, []]))
            })
    }

// Overview Actions
// Fetch Overview
export const fetchOverview =
    (params: OverviewParams): AppThunk =>
    (dispatch: any, getState) => {
        dispatch(setOverviewLoading(true))
        const dealerId = params.selectedDealer === null ? 0 : params.selectedDealer.dealerId
        const start = dayjs(params.dateRange.start).startOf("day").format("YYYY-MM-DD")
        const end = dayjs(params.dateRange.end).endOf("day").format("YYYY-MM-DD")

        httpService(getAccessToken(getState()))
            .get(`regions/${getSelectedRegionId(getState())}/dealers/${dealerId}/overview?start=${start}&end=${end}`)
            .then(res => dispatch(setOverviews(res.data as Overview[])))
            .catch(error => dispatch(setOverviews([])))
            .finally(() => dispatch(setOverviewLoading(false)))
    }

// Fee report Actions
// Fetch Fee report
export const fetchFeesReport =
    (param: FeesReportParams): AppThunk =>
    (dispatch: any, getState) => {
        const formatAsDate = (dateColumn: Date | null) =>
            dateColumn !== null ? dayjs(dateColumn).startOf("day").toDate() : null
        const regionId = getSelectedRegionId(getState())
        dispatch(setFeeReportLoader(true))
        const selectedDealer = param.dealerIds.map(id => id.dealerId).join("~")

        if (param.dateRange.start !== null && param.dateRange.end !== null) {
            const startDate = getStartDay(param.dateRange.start).format("YYYY-MM-DDTHH:mm:ss")
            const endDate = getEndDay(param.dateRange.end).format("YYYY-MM-DDTHH:mm:ss")
            httpService(getAccessToken(getState()))
                .get(
                    `regions/${regionId}/dealers/${selectedDealer}/feesreport?start=${startDate}&end=${endDate}&searchText=${param.searchText}`,
                )
                .then(res => {
                    const feeReportData = res.data.map((d: any) => ({
                        ...d,
                        date: formatAsDate(d.date),
                        updatedDate: formatAsDate(d.updatedDate),
                        manufactureDate: formatAsDate(d.manufactureDate),
                        registrationDate: formatAsDate(d.registrationDate),
                        annualTestExpiryDate: formatAsDate(d.annualTestExpiryDate),
                        reminderCall:
                            d.bookingTypeID === 1 && (d.reminderCall ?? false)
                                ? "Called"
                                : d.bookingTypeID === 1 &&
                                  (!d.reminderCall) &&
                                  dayjs(d.testStart).diff(dayjs(), "hour") > 0
                                ? "Pending"
                                : "",
                        sendreminderEmail: d.sendReminderEmail && d.email !== null ? "Yes" : "No",
                        expiryDate: formatAsDate(d.expiryDate),
                        annualTestDate: formatAsDate(d.annualTestDate),
                        preparedByDealer: d.preparedByDealer ? "Yes" : "No",
                        validResults: d.validResultReason === 0 ? "Yes" : "No",
                        validResultReason: getReason(d.validResultReason),
                    }))
                    dispatch(setFeeReportData(feeReportData))
                    dispatch(setFeeReportLoader(false))
                })
                .catch(err => {
                    dispatch(setFeeReportData([]))
                    dispatch(setFeeReportLoader(false))
                })
        }
    }
const getReason=(validResultReason: any): string=>{
    switch(validResultReason){
        case 0:
            return ""
        case 1:
            return "Missing/Incorrect Vehicle details"
        case 2:
            return "Booking and MOT dates mismatch"
        case 3:
            return "Duplicate - Recent MOT detected"
        default:
            return ""
    }
}
export const fetchBookingReminder =
    (selectedDealerId: any): AppThunk =>
    (dispatch: any, getState) => {
        dispatch(setBookingReminderLoading(true))
        // dispatch(showLoader(true))
        const formatAsDate = (dateColumn: Date | null) =>
            dateColumn !== null ? dayjs(dateColumn).startOf("day").toDate() : null
        httpService(getAccessToken(getState()))
            .get(`regions/${getSelectedRegionId(getState())}/dealers/${selectedDealerId}/booking-reminder`)
            .then(res => {
                const bookingReminderData = res.data.map((data: BookingReminder) => ({
                    ...data,
                    testStart: formatAsDate(data.testStart),
                    reminderCall: data.reminderCall ? "Called" : "Pending",
                    reminderEmail: data.reminderEmail === null ? "" : data.reminderEmail ? "Sent" : "Scheduled",
                    confirmationEmail:
                        data.confirmationEmail === null ? "" : data.confirmationEmail ? "Sent" : "Pending",
                    isEmailEmpty: data.confirmationEmail === null,
                }))
                dispatch(getBookingReminder(bookingReminderData))
            })
            .catch(err => {
                let error = err.response?.data.Value as ErrorMessage
                dispatch(
                    setToastr({
                        isActive: true,
                        message: error.Error,
                        delay: 3000,
                        title: "Error",
                        type: "danger",
                        description: error.Description,
                    }),
                )
            })
            .finally(() => dispatch(setBookingReminderLoading(false)))
    }

export const fetchBookingUpdateInfo =
    (selectedBookingId: number): AppThunk =>
    (dispatch: any, getState) => {
        dispatch(showDataLogModal(true))
        httpService(getAccessToken(getState()))
            .get(`regions/${getSelectedRegionId(getState())}/bookinglog/${selectedBookingId}`)
            .then(res => {
                const bookingupdateinfo = res.data.map((data: any) => ({
                    ...data,
                    dateTimeStamp: dayjs(data.dateTimeStamp).format("DD/MM/YYYY hh:mm"),
                }))
                dispatch(getBookingUpdateInfo(bookingupdateinfo))
                dispatch(showDataLogModal(false))
            })
            .catch(error => {
                dispatch(getBookingUpdateInfo([]))
                dispatch(showDataLogModal(false))
            })
    }

export const printforDVSA =
    (param: BookingParams): AppThunk =>
    (dispatch: any, getState) => {
        dispatch(loadingBooking(true))
        const dealerId = param.selectedDealer === null ? 0 : param.selectedDealer.dealerId
        const startDate = dayjs(param.start).startOf("day").format("YYYY-MM-DDTHH:mm:ss")
        httpService(getAccessToken(getState()))
            .post(
                `regions/${getSelectedRegionId(
                    getState(),
                )}/dealers/${dealerId}/bookings/dvsa-export?start=${startDate}`,
            )
            .then((res: any) => {
                dispatch(loadingBooking(false))
                convertReport(res.data, res.data.fileDownloadName)
            })
            .catch((err: any) => {
                dispatch(loadingBooking(false))
                dispatch(
                    setToastr({
                        isActive: true,
                        message: "Could not download the requested report.",
                        delay: 3000,
                        title: "Download Failed",
                        type: "danger",
                        description: "",
                    }),
                )
            })
    }

export const downloadMotCertificate =
    (fileName: string): AppThunk =>
    (dispatch: any, getState) => {
        dispatch(showDownloadLoader(true))
        httpService(getAccessToken(getState()))
            .get(
                `regions/${getSelectedRegionId(getState())}/booking/${
                    getState().containers.motBooking.selectedBookingId
                }/mot-certificate?fileName=${fileName}`,
            )
            .then(res => {
                convertReport(res.data, fileName + ".pdf")
                dispatch(showDownloadLoader(false))
            })
            .catch((err: any) => {
                let error = err.response?.data.Value as ErrorMessage

                dispatch(
                    setToastr({
                        isActive: true,
                        message: error.Error,
                        delay: 3000,
                        title: "Error",
                        type: "danger",
                        description: error.Description == null ? "" : error.Description,
                    }),
                )
            })
            .finally(() => {
                dispatch(showDownloadLoader(false))
            })
    }

export const checkBlobCertificateExists =
    (fileName: string): AppThunk =>
    (dispatch: any, getState) => {
        dispatch(setExistsLoader(true))
        httpService(getAccessToken(getState()))
            .get(
                `regions/${getSelectedRegionId(getState())}/booking/${
                    getState().containers.motBooking.selectedBookingId
                }/blob-exists?fileName=${fileName}`,
            )
            .then(res => {
                dispatch(setBlobExists(res.data))
                dispatch(setExistsLoader(false))
            })
            .catch((err: any) => {
                dispatch(setBlobExists(false))
                dispatch(setExistsLoader(false))

                let error = err.response?.data.Value as ErrorMessage
                dispatch(
                    setToastr({
                        isActive: true,
                        message: error.Error,
                        delay: 3000,
                        title: "Error",
                        type: "danger",
                        description: error.Description == null ? "" : error.Description,
                    }),
                )
            })
    }

export const deleteMotCertificate =
    (fileName: string): AppThunk =>
    (dispatch: any, getState) => {
        dispatch(showDeleteLoader(true))
        httpService(getAccessToken(getState()))
            .delete(
                `regions/${getSelectedRegionId(getState())}/booking/${
                    getState().containers.motBooking.selectedBookingId
                }/mot-certificate?fileName=${fileName}`,
            )
            .then(res => {
                dispatch(showDeleteLoader(false))
                if (res.data.value) {
                    dispatch(setBlobExists(false))
                }
            })
            .catch((err: any) => {
                let error = err.response?.data.Value as ErrorMessage
                dispatch(
                    setToastr({
                        isActive: true,
                        message: error.Error,
                        delay: 3000,
                        title: "Error",
                        type: "danger",
                        description: error.Description == null ? "" : error.Description,
                    }),
                )
            })
            .finally(() => {
                dispatch(showDeleteLoader(false))
            })
    }

export const uploadMotCertificate =
    (base64Result: string, fileName: string, selectedRegionId: number, selectedBookingId: number | null): AppThunk =>
    (dispatch: any, getState) => {
        httpService(getAccessToken(getState()))
            .post(`regions/${selectedRegionId}/booking/${selectedBookingId}/mot-certificate/${fileName}`, base64Result)
            .catch((err: any) => {
                let error = err.response?.data.Value as ErrorMessage
                dispatch(
                    setToastr({
                        isActive: true,
                        message: error.Error,
                        delay: 3000,
                        title: "Error",
                        type: "danger",
                        description: error.Description == null ? "" : error.Description,
                    }),
                )
            })
    }
